
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/edition/[category]/[articleTaxonomy]/[slug]",
      function () {
        return require("private-next-pages/[lang]/edition/[category]/[articleTaxonomy]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/edition/[category]/[articleTaxonomy]/[slug]"])
      });
    }
  